// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"361":"91c0a0f6","487":"ae597971","628":"c5380b83","647":"ae597971","672":"26837502","688":"4a268324","690":"f099a0c7","723":"26837502","817":"07837dfa","824":"ae597971","965":"f9601170"}[chunkId] + ".chunk.css";
};